/**
 * entity model class
 *
 * This file is part of Minasa
 * (c) Kaden und Partner AG
 */
import BaseModel from './BaseModel';
import BaseCollection from './BaseCollection';
import dayjs from 'dayjs';

export class Album extends BaseModel {
    defaults() {
        return {
            id: null,
            title: null,
            description: null,
            created: null,
            creator_id: null,
            parent_album_id: null,
            event_organizer_id: null,

            // view props:
            user_username: null,
            user_firstname: null,
            user_lastname: null,
            user_email: null,
            user_initials: null,

            // virtual, filled during runtime:
            children: [],
        };
    }

    get parent() {
        if (this._parent) {
            return this._parent;
        }
        return null;
    }

    set parent(value) {
        this._parent = value;
    }

    mutations() {
        return {
            id: Number,
            created: dayjs,
            children: (data) => {
                if (data && data.length) {
                    return data.map((d) => {
                        let a = new Album({ ...d });
                        a.parent = this;
                        return a;
                    });
                }
                return [];
            },
        };
    }

    entityName() {
        return 'album';
    }

    async loadChildren(force = false) {
        if (force || this.children.length === 0) {
            let collection = new AlbumCollection();
            await collection.query({
                node: this.id,
            });
            collection.each((item) => {
                item.parent = this;
            });
            this.children = [...collection.models];
        }
    }

    addChild(album) {
        this.children = [...this.children, album];
    }

    removeChild(album) {
        album.parent = null;
        this.children = this.children.filter((c) => c !== album);
    }

    /**
     * Searches for an album by a specific attribute in the hierarchy.
     * @param {String} key The property name to search
     * @param {any} value The value to match
     */
    findAlbumBy(key, value) {
        if (this.get(key) === value) {
            return this;
        }
        for (const c of this.children) {
            let ret = c.findAlbumBy(key, value);
            if (ret) {
                return ret;
            }
        }
        return null;
    }
}

export class AlbumCollection extends BaseCollection {
    options() {
        return {
            model: Album,
        };
    }

    entityName() {
        return 'album';
    }
}
